import "./map.css"
import { useTranslation } from 'react-i18next';

export default function Map() {
    const { i18n } = useTranslation();

    return (
        <div className={`container text-center googleMap`}>
            <iframe
                src={i18n.language === 'en' ?
                    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4323.661300586444!2d46.805313999999996!3d24.689829099999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f07722d17bce9%3A0x52eb3134dd92cdee!2z2YXYs9in2LEg2KfZhNiq2YXZitiyINmE2KrZgtmG2YrYqSDYp9mE2YXYudmE2YjZhdin2Ko!5e1!3m2!1sen!2ssa!4v1745868921374!5m2!1sen!2ssa" :
                    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4323.661300586444!2d46.805313999999996!3d24.689829099999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f07722d17bce9%3A0x52eb3134dd92cdee!2z2YXYs9in2LEg2KfZhNiq2YXZitiyINmE2KrZgtmG2YrYqSDYp9mE2YXYudmE2YjZhdin2Ko!5e1!3m2!1sar!2ssa!4v1745869191443!5m2!1sar!2ssa"}
                className="border-0 rounded w-75 h-100"
                loading="lazy"
                title="office Location"
            ></iframe>
        </div>
    )

}

